import { render, staticRenderFns } from "./CandidateRegistrationComponent.vue?vue&type=template&id=2822adb8&"
import script from "./CandidateRegistrationComponent.vue?vue&type=script&lang=js&"
export * from "./CandidateRegistrationComponent.vue?vue&type=script&lang=js&"
import style0 from "./CandidateRegistrationComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports